$(document).ready(function(){
  $(".custom-banner__wrapper").slick({
      slidesToShow: 1,
      infinite: false,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: false,
    });
});
$(window).scroll(function() {
    if ($(this).scrollTop() > 900) {
        // Add class when scrolled more than 200px
        $('.sticky-form').addClass('stickey-product');
    } else {
        // Remove class when scrolled less than 200px
        $('.sticky-form').removeClass('stickey-product');
    }
});
document.addEventListener("DOMContentLoaded", function () {
    // Select the variant selector
    const variantSelectors = document.querySelectorAll("variant-selects input[type='radio']");

    if (!variantSelectors) return;

    // Add event listener to each variant option
    variantSelectors.forEach(variant => {
        variant.addEventListener("change", function () {
            let selectedVariantId = this.getAttribute("data-option-value-id");
            let selectedVariantData = document.querySelector("script[data-selected-variant]");

            if (!selectedVariantData) return;

            let variant = JSON.parse(selectedVariantData.textContent);

            // Find the matching variant by ID
            let selectedVariant = variant.id == selectedVariantId ? variant : null;

            if (selectedVariant) {
                updateStickyForm(selectedVariant);
            }
        });
    });

    function updateStickyForm(variant) {
        // Update product image
        let stickyImage = document.querySelector(".stickey-img-left img");
        if (stickyImage) {
            stickyImage.src = variant.featured_image?.src || "";
        }

        // Update product title
        let stickyTitle = document.querySelector(".stickey-img-right h3");
        if (stickyTitle) {
            stickyTitle.textContent = variant.title;
        }

        // Update product price
        let stickyPrice = document.querySelector(".stickey-img-right .price");
        if (stickyPrice) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                stickyPrice.innerHTML = `
                    <span class="old-price">₹${(variant.compare_at_price / 100).toFixed(2)}</span>
                    <span class="new-price">₹${(variant.price / 100).toFixed(2)}</span>
                `;
            } else {
                stickyPrice.innerHTML = `₹${(variant.price / 100).toFixed(2)}`;
            }
        }

        // Update Add to Cart button variant ID
        let addToCartInput = document.querySelector(".product-variant-id");
        if (addToCartInput) {
            addToCartInput.value = variant.id;
        }
    }
});

// New

document.addEventListener("DOMContentLoaded", function () {
  // --- Sticky Bar Elements ---
  const stickyBar = document.getElementById("sticky-atc-bar");
  const stickyImage = document.getElementById("sticky-product-image");
  const stickyTitle = document.getElementById("sticky-product-title");
  const stickyPrice = document.getElementById("sticky-product-price");
  const stickyAddToCart = document.getElementById("sticky-add-to-cart");

  // --- Build a Mapping from Option Text to Actual Variant ID ---
  // Assumes the full product JSON is output in a script tag with id "ProductJson"
  let variantMapping = {};
  try {
    const productDataElement = document.getElementById("ProductJson");
    if (productDataElement) {
      const productData = JSON.parse(productDataElement.textContent);
      productData.variants.forEach(variant => {
        // Use variant.option1 trimmed as key.
        variantMapping[variant.option1.trim()] = variant.id;
      });
      console.log("Variant Mapping:", variantMapping);
    } else {
      console.warn("Product JSON not found – mapping will be empty.");
    }
  } catch (error) {
    console.error("Error parsing product JSON:", error);
  }

  // --- Function: Update the Sticky Bar Based on a Given Radio Input ---
  function updateStickyBarFromRadio(radio) {
  const label = document.querySelector(`label[for="${radio.id}"]`);
  if (!label) return;

  // ✅ Use Product JSON to get clean title instead of label text
  const radioValue = radio.value.trim();
  const correctVariantId = variantMapping[radioValue];

  if (correctVariantId) {
    const productData = JSON.parse(document.getElementById("ProductJson").textContent);
    const matchedVariant = productData.variants.find(v => v.id === correctVariantId);

    if (matchedVariant) {
      // Use Shopify's clean variant title
      stickyTitle.textContent = matchedVariant.title;

      // Update image
      stickyImage.src = matchedVariant.featured_image?.src || "";

      // Update price
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        stickyPrice.innerHTML = `
          <span class="new-price">₹${(matchedVariant.price / 100).toFixed(2)}</span>
          <span class="old-price" style="text-decoration: line-through;">₹${(matchedVariant.compare_at_price / 100).toFixed(2)}</span>
        `;
      } else {
        stickyPrice.innerHTML = `₹${(matchedVariant.price / 100).toFixed(2)}`;
      }
    }

    // Update Add to Cart button
    stickyAddToCart.setAttribute("data-variant-id", correctVariantId);
  }
}
  
  // --- Event Delegation for Radio Input Changes ---
  // Listen for change events on document in case the radios are re-rendered.
  document.addEventListener("change", function (e) {
    const target = e.target;
    if (target && target.type === "radio" && target.closest("variant-selects")) {
      console.log("Radio changed:", target.value);
      updateStickyBarFromRadio(target);
    }
  });

  // --- On Page Load: Update Sticky Bar with Initially Checked Radio ---
  (function initializeStickyBar() {
    let initialRadio = document.querySelector("variant-selects input[type='radio']:checked");
    if (!initialRadio) {
      initialRadio = document.querySelector("variant-selects input[type='radio']");
    }
    if (initialRadio) {
      updateStickyBarFromRadio(initialRadio);
    }
  })();

  // --- AJAX Add to Cart with Minicart Open ---
  stickyAddToCart.addEventListener("click", function () {
    const variantId = this.getAttribute("data-variant-id");
    console.log("Attempting to add variant:", variantId);
    if (!variantId) return;
    
    const formData = { id: variantId, quantity: 1 };
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("Error adding product to cart");
      }
      return response.json();
    })
    .then(data => {
      console.log("Product added to cart:", data);
      // Instead of redirecting, simulate a click on the cart icon to open the minicart.
      openMiniCart();
      updateCartCount();
    })
    .catch(error => {
      console.error("AJAX Add to Cart Error:", error);
    });
  });

  // --- Function: Open the Minicart by Triggering a Click on the Cart Icon ---
  function openMiniCart() {
    const cartIcon = document.getElementById("cart-icon-bubble");
    if (cartIcon) {
      cartIcon.click();
    } else {
      console.warn("Cart icon element not found.");
    }
  }

  // --- Function: Update Cart Count (Optional) ---
  function updateCartCount() {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        console.log("Updated cart data:", cart);
        const cartCountEl = document.querySelector(".cart-count");
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }
      })
      .catch(error => console.error("Error updating cart count:", error));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("sticky-atc-bar");
  const buttonDiv = document.querySelector(".product-form__buttons");

  if (!stickyBar || !buttonDiv) {
    console.warn("Required elements not found.");
    return;
  }

  // Function to check the position of the buttonDiv relative to the viewport
  function checkStickyBar() {
    const rect = buttonDiv.getBoundingClientRect();
    // When the top of buttonDiv is less than -50px (i.e. 50px above viewport), show sticky bar.
    if (rect.top < -50) {
      stickyBar.classList.remove("hiddennn");
    } else {
      stickyBar.classList.add("hiddennn");
    }
  }

  // Run once on load
  checkStickyBar();
  
  // Listen to scroll events
  window.addEventListener("scroll", checkStickyBar);
});

// document.addEventListener('DOMContentLoaded', () => {
//   // Delay a bit so slider fully loads
//   setTimeout(() => {
//     const slides = document.querySelectorAll('.pmslider-slide');
//     if (!slides.length) return;

//     // Remove the last slide element from DOM
//     slides[slides.length - 1].remove();

//     // Optionally, you can try to force a reflow/repaint:
//     const sliderContainer = document.querySelector('.pmslider-slide').parentNode;
//     if (sliderContainer) {
//       sliderContainer.style.display = 'none';
//       // Force reflow
//       void sliderContainer.offsetHeight;
//       sliderContainer.style.display = '';
//     }

//     console.log('Last slide removed');
//   }, 1000); // Adjust timeout if needed
// });
